'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

require('./style');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_input2.default.displayName = 'Input';

_input2.default.defaultProps = {
  prefixCls: 'grab-ui ant-input'
};

_input2.default.propTypes = {
  prefixCls: _propTypes2.default.string
};

exports.default = _input2.default;